import { z } from 'zod'
import { AddressDtoSchema } from '../domain/Address/Address'
import { bzOptional, Guid } from '../domain/common-schemas'
import { guidSchema } from './_common'

export const ServiceLocationGuidSchema = guidSchema.transform(value => value.toLowerCase())

export const ServiceLocationSchema = z.object({
  address: AddressDtoSchema,
  addressGuid: guidSchema,
  locationGuid: bzOptional(guidSchema),
  displayName: bzOptional(z.string()),
})
export type ServiceLocation = z.infer<typeof ServiceLocationSchema>

export const DocumentServiceLocationsInputSchema = z.object({
  documentType: z.enum(['invoice', 'estimate']),
  documentGuids: z.array(ServiceLocationGuidSchema).min(1).max(100),
})
export const DocumentServiceLocationsOutputSchema = z.record(guidSchema, ServiceLocationSchema.nullable())
export const ServiceLocationSelectionInputSchema = z.object({
  accountGuid: ServiceLocationGuidSchema,
  locationGuid: ServiceLocationGuidSchema,
})
export const EstimateJobServiceLocationInputSchema = z.object({ jobGuid: ServiceLocationGuidSchema })
export const PublicServiceLocationSchema = ServiceLocationSchema.pick({ address: true, displayName: true })

export type DocumentServiceLocationReader = (
  input: z.infer<typeof DocumentServiceLocationsInputSchema> & {
    companyGuid: Guid | null
    assignedUserGuid?: Guid
  },
) => Promise<z.infer<typeof DocumentServiceLocationsOutputSchema>>

export type SelectedServiceLocationReader = (
  input: z.infer<typeof ServiceLocationSelectionInputSchema> & { companyGuid: Guid; assignedUserGuid?: Guid },
) => Promise<ServiceLocation | null>

export type EstimateJobServiceLocationReader = (
  input: z.infer<typeof EstimateJobServiceLocationInputSchema> & { companyGuid: Guid; assignedUserGuid?: Guid },
) => Promise<ServiceLocation | null>
